import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import HomePage  from '../pages/HomePage';
import NotePage  from '../pages/NotePage';
import TitleManager from "../components/TitleManager"

const Router:React.FC = ()=>(
  <BrowserRouter>
  <TitleManager /> 
    <Routes>
      <Route path="/" element={<HomePage />} />
      <Route path="/shared/:noteId" element={<NotePage />} />
      {/* 其他页面继续追加 */}
    </Routes>
  </BrowserRouter>
);
export default Router;

